import { SearchButton } from "./RightActionBlock/SearchButton";

export const SettingsSearchBar = () => (
  <div className="absolute inset-1/2 top-0 flex size-full -translate-x-1/2 list-none items-center justify-center gap-4">
    <SearchButton isLarge />
  </div>
);
